<template>
    <div>
        <div class="content-header row">
            <div class="content-header-left col-md-6 col-12 mb-2">
                <h3 class="content-header-title mb-0">Admins</h3>
                <div class="row breadcrumbs-top">
                    <div class="breadcrumb-wrapper col-12">
                        <ol class="breadcrumb">
                            <li class="breadcrumb-item"><a href="/">Home</a>
                            </li>
                            <li class="breadcrumb-item active">Admins
                            </li>
                        </ol>
                    </div>
                </div>
            </div>
        </div>

        <div class="content-body">
            <section class="card">

                <div class="card-body">
                    <form novalidate @submit.prevent="saveAdmin" autocomplete="off">
                        <div class="row">
                            <div class="col-12 col-sm-6">
                                <div class="form-group">
                                    <div class="controls">
                                        <label>First Name</label>
                                        <input type="text" v-model="admin.first_name" class="form-control"
                                               placeholder="First name"
                                               required>
                                        <div v-if="admin.errors.first_name" class="text-danger text-small">
                                            {{ admin.errors.first_name }}
                                        </div>
                                    </div>
                                </div>
                                <div class="form-group">
                                    <div class="controls">
                                        <label>Current Password</label>
                                        <input type="password" class="form-control" v-model="admin.old_password"
                                               placeholder="Current Password"
                                               required>
                                        <div v-if="admin.errors.old_password" class="text-danger text-small">
                                            {{ admin.errors.old_password }}
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="col-12 col-sm-6">
                                <div class="form-group">
                                    <div class="controls">
                                        <label>Last Name</label>
                                        <input type="text" v-model="admin.last_name" class="form-control"
                                               placeholder="Last name"
                                               required>
                                        <div v-if="admin.errors.last_name" class="text-danger text-small">
                                            {{ admin.errors.last_name }}
                                        </div>
                                    </div>
                                </div>

                                <div class="form-group">
                                    <div class="controls">
                                        <label>New Password</label>
                                        <input type="password" class="form-control" v-model="admin.new_password"
                                               placeholder="New Password"
                                               required>
                                        <div v-if="admin.errors.new_password" class="text-danger text-small">
                                            {{ admin.errors.new_password }}
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="col-12 d-flex flex-sm-row flex-column justify-content-end mt-1">
                                <button type="submit" class="btn btn-primary glow mb-1 mb-sm-0 mr-0 mr-sm-1"
                                        :disabled="saving">
                                    {{ 'Update' }}
                                    <i class="fa fa-spinner fa-spin" v-if="saving"/>
                                </button>
                            </div>
                        </div>
                    </form>
                </div>
            </section>
        </div>
    </div>
</template>

<script>
import Layout from '@/Shared/Layout'

export default {
    metaInfo: {title: 'Edit Profile'},
    name: 'EditProfile',
    props: ['adminData',],
    layout: Layout,
    data() {
        return {
            admin: this.$inertia.form({
                first_name: "",
                last_name: "",
                old_password: "",
                new_password: "",
            }),
            saving: false
        }
    },
    methods: {
        async saveAdmin() {
            this.saving = true;
            this.admin.post(route('admin.admins.update-profile'), this.admin, {
                preserveScroll: true,
                onSuccess: () => {
                    this.saving = false
                    // if (response.props.password_changed) {
                    //     alert("Password changed successfully. You will be logged out.");
                    //     document.getElementById('logout-form').submit();
                    // }
                },
                onError: () => {
                    this.saving = false;
                }
            });
            this.saving = false
        }
    },
    mounted() {
        this.admin.first_name = this.adminData.first_name
        this.admin.last_name = this.adminData.last_name
    },
}
</script>
